import { siteConfig } from "@/config/site";

/**
 * Origine du site, y compris au rendu serveur.
 *
 * `window` est absent côté serveur et `VITE_SITE_URL` n'est pas garanti au
 * build. Sans dernier recours, les constructeurs de JSON-LD renvoyaient le
 * chemin relatif tel quel et le balisage sortait avec des URL du type
 * "/cours/paris" ou "/" — invalides pour un consommateur externe, qui n'a
 * aucun moyen de les résoudre.
 *
 * Ce module est l'unique source : la logique était auparavant dupliquée dans
 * localPageStructuredData, seoSerp et la page annonce, chacune avec le même
 * défaut.
 */
export const getSiteOrigin = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return import.meta.env.VITE_SITE_URL || siteConfig.url;
};

export const toAbsoluteUrl = (path: string) => {
  const origin = getSiteOrigin();

  if (!path) return origin;
  if (/^https?:\/\//i.test(path)) return path;
  if (!origin) return path;

  return `${origin}${path.startsWith("/") ? "" : "/"}${path}`;
};
